var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF5100",
    clipPath: "url(#medal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.375 8.156 1.146 1.987a.583.583 0 0 1-.41.868l-.067.007-.065-.001-1.711-.11-.76 1.537a.585.585 0 0 1-.938.151l-.048-.054-.042-.065-1.148-1.987a5.25 5.25 0 0 0 4.042-2.333M6.669 10.49l-1.147 1.988a.584.584 0 0 1-.946.091l-.045-.058-.037-.067-.76-1.537-1.71.111a.584.584 0 0 1-.596-.752l.023-.063.03-.058 1.147-1.989a5.25 5.25 0 0 0 4.04 2.334M7.001 1.166l.14.002a4.083 4.083 0 0 1 3.944 4.081l-.002.113-.004.112-.01.143-.016.141-.014.104q-.057.379-.185.74l-.067.18-.09.202a4.084 4.084 0 0 1-7.401-.016l-.076-.173-.03-.078-.047-.127-.055-.171a4 4 0 0 1-.055-.2l-.035-.159-.028-.158-.012-.081-.023-.188-.014-.213-.003-.17a4.083 4.083 0 0 1 3.943-4.082z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgMedal;